var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validTiles.length > 0
    ? _c(
        "div",
        {
          staticClass: "super-collection-linear",
          class:
            ((_obj = {
              "super-collection-linear--with-background":
                _vm.settings.background
            }),
            (_obj[_vm.settings.backgroundColor] = _vm.settings.backgroundColor),
            _obj),
          style: {
            backgroundImage: _vm.settings.background
              ? "url(" + _vm.settings.background + ")"
              : ""
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "super-collection-linear__content" }, [
              _vm.settings.heading
                ? _c(
                    "header",
                    { staticClass: "super-collection-linear__heading" },
                    [
                      _c(
                        "h4",
                        {
                          staticClass: "text-center",
                          class: _vm.settings.headingColor
                        },
                        [_vm._v(_vm._s(_vm.settings.heading))]
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "super-collection-linear__tile-container" },
                _vm._l(_vm.settings.linearArray, function(tile, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      staticClass: "super-collection-linear__tile",
                      attrs: { href: tile.url }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "super-collection-linear__tile-image-wrapper bg-white"
                        },
                        [
                          _c("img", {
                            staticClass: "super-collection-linear__tile-image",
                            attrs: { src: tile.image, alt: tile.title }
                          })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "super-collection-linear__tile-title text-center color-off-black"
                        },
                        [_vm._v(_vm._s(tile.title))]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }